<template>
  <core-view>
    <div>
      <!-- Espaço para futuros filtros globais, se necessário -->
    </div>

    <component :is="componenteAtivo" :filters="filters" :cliente="cliente" :origem="rotaDeOrigem" @limpar-origem="limparOrigem" />

  </core-view>
</template>

<script>
import CoreView from '@/components/core/view/Index.vue';
import moment from 'moment';
import Financeiro from '@/components/app/card/dadoscliente/financeiro/Index.vue';
import Vendas from '@/components/app/card/dadoscliente/vendas/Index.vue';


export default {
  name: 'ViewFinanceiro',

  components: {
    CoreView,
    Financeiro,
    Vendas,
  },

  data() {
    return {
      filtroAtivo: null,
      cliente: { nome: '', codigo: '' },
      filters: {},
      rotaDeOrigem: null,
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.rotaDeOrigem = to.query.origem || null; 
    });
  },

  beforeRouteLeave(to, from, next) {
    this.rotaDeOrigem = null;
    next();
  },

  created() {
    const abaAtiva = this.$route.query.aba;
    this.cliente = {
      nome: this.$route.query.clienteNome,
      codigo: this.$route.query.clienteCodigo,
    };
    this.filtroAtivo = abaAtiva || 'Vendas';
  },

  computed: {
    componenteAtivo() {
      const componentes = {
        financeiro: 'Financeiro',
        vendas: 'Vendas',
        motivos: 'Motivos',
      };
      return componentes[this.filtroAtivo] || 'Vendas';
    },
  },
  methods: {
    FormataDataGeral(date) {
      return moment.utc(date).format('DD/MM/YYYY');
    },
    limparOrigem() {
      this.rotaDeOrigem = null;
    }
  },
};
</script>
<style scoped>
.linha_botoes {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.btn {
  width: auto;
  min-width: 0px !important;
  padding: 0 1.5vw 0 1.5vw  !important;
}

@media screen and (max-width: 375px) {
  .btn {
    margin: 3px !important;
    margin-bottom: 8px !important;
  }
}

.center-text {
  display: flex;
  justify-content: center;
}

.ultimo {
  justify-self: right;
}

</style>
